export const handlingUrlParams = (data: any) => {
  return Object.keys(data)
    .map(
      (key) =>
        `${key}=${encodeURIComponent(
          data[key] === undefined ? null : data[key]
        )}`
    )
    .join("&");
};
